import DZModelPage from "@/model/DZModelPage";

class DZSearchCourtship extends DZModelPage{

    /**
     * 区域ID
     */
    county = "";

    countyArr = [];

    level = "";

    /**
     * 发布时间
     */
    releaseTime = "";

    status;
}
export default DZSearchCourtship;
